var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('h1',{staticClass:"title"},[_vm._v("详情")]),_c('div',{staticClass:"info"},[_vm._v("\n    abc\n  ")])])
}]

export { render, staticRenderFns }